import TurndownService from 'turndown';

export function initTurndownService () {
    const turndownService = new TurndownService();

    turndownService.addRule('underline', {
        filter: ['u'],
        replacement: (content, node) => {
            const { childNodes } = node;
            const noContent = childNodes.length === 0 || (childNodes.length === 1 && childNodes[0].nodeName === 'BR');

            return noContent ? content : `++${content}++`;
        },
    });

    turndownService.addRule('paragraph', {
        filter: ['p'],
        replacement: (content, node) => {
            const { childNodes } = node;

            // Turndown  will remove new lines without content so we need to add a zero-width space to keep the new line
            if (childNodes.length === 1 && childNodes[0].nodeName === 'BR') {
                return '\u200C\n';
            }

            return `${content}\u200C\n`;
        },
    });

    turndownService.addRule('div', {
        filter: ['div'],
        replacement: (content) => {
            // This is needed to prevent new lines added by turndown for divs
            return content;
        },
    });

    // // spans containing a <br> be goofin everything up so filter them out
    turndownService.addRule('span', {
        filter: ['span'],
        replacement: (content, node) => {
            const { childNodes } = node;
            if (childNodes.length === 0) return '';

            const hasOneChild = childNodes.length === 1;
            const childNodeName = childNodes[0].nodeName;
            const parentNodeChildren = node.parentNode.childNodes;
            const isLastChildOfParent = parentNodeChildren[parentNodeChildren.length - 1] === node;

            // Turndown  will remove new lines without content so we need to add a zero-width space to keep the new line
            if (hasOneChild && childNodeName === 'BR') {
                return '\u200C\n';
            }

            if (hasOneChild && childNodeName === '#text' && isLastChildOfParent) {

                return `${content}\n`;
            }

            return content;
        },
    });

    turndownService.addRule('listItem', {
        filter: ['li'],
        replacement: (content, node, options) => {
            // removes random extra spaces added by turndown before listitem content
            const defaultReplacement = options.rules.listItem.replacement(content, node, options);
            const [listItemPrefix] = defaultReplacement.match(/^([^ ]+) +/);
            const replacement = defaultReplacement.replace(listItemPrefix, `${listItemPrefix.trim()} `);

            return replacement;
        },
    });

    function turndown (dom) {
        const clonedDom = dom.cloneNode(true);
        const markdownText = turndownService.turndown(clonedDom);
        // We need to clean the zero-width space that we added above
        const cleanedMarkdownText = markdownText.replace(/\u200C/g, '');

        return cleanedMarkdownText;
    }

    return { turndown };
}
